import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-center gap-x-4 mt-6" }

import { ref } from 'vue';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import BasePopupForm from '../Popup/BasePopupForm.vue';
import CardMessage from '@/components/global/Message/messageCard.vue';
import BaseBtn from '@/components/global/button/baseBtn.vue';

interface TypeChagneCroper {
    coordinates: any
    canvas: any
}
interface Props {
    srcImgCroper: any
    showPopupCroper: any
    name: string
    type: string
    loading: boolean
    dataErrCroper: string
    showCardMessage: Boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCropper',
  props: {
    srcImgCroper: null,
    showPopupCroper: null,
    name: null,
    type: null,
    loading: { type: Boolean },
    dataErrCroper: null,
    showCardMessage: null
  },
  emits: ["close", "submit"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'close', payload: MouseEvent): void
    (event: 'submit', payload: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    srcImgCroper: any
    showPopupCroper: any
    name: string
    type: string
    loading: boolean
    dataErrCroper: string
    showCardMessage: Boolean
};





const FileImg = ref<File>()
const srcPhoto = ref<any>()

function change({ coordinates, canvas }: TypeChagneCroper) {
    srcPhoto.value = canvas.toDataURL()

    let newImage = canvas.toDataURL("image/png");
    let blobBin: any = atob(newImage.split(',')[1]);
    let array: any = [];
    for (var i: any = 0; i < blobBin.length; i++) {
        array.push(blobBin.charCodeAt(i));
    }
    let newBlob = new Blob([new Uint8Array(array)], { type: props.type });
    FileImg.value = new File([newBlob], props.name, { type: props.type });
}

function submitCrop() {
    const data = {
        file: FileImg.value,
        img: srcPhoto.value
    }
    emit('submit', data)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopupForm, {
    status: __props.showPopupCroper,
    title: "",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
    class: "z-50"
  }, {
    form: _withCtx(() => [
      _createVNode(_unref(Cropper), {
        ref: "cropper",
        debounce: false,
        class: "cropper",
        src: __props.srcImgCroper,
        onChange: change,
        canvas: {
                minHeight: 200,
                minWidth: 200,
                maxHeight: 300,
                maxWidth: 300,
            }
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BaseBtn, {
          type: "button",
          "style-btn": "btn-cancel",
          text: "انصراف",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }),
        _createVNode(BaseBtn, {
          type: "button",
          "style-btn": "btn-confirm",
          text: "تایید",
          status: __props.loading,
          onClick: submitCrop
        }, null, 8, ["status"])
      ]),
      _createVNode(CardMessage, {
        "style-message": "message-error",
        icon: "warning.png",
        msg: __props.dataErrCroper,
        status: __props.showCardMessage
      }, null, 8, ["msg", "status"])
    ]),
    _: 1
  }, 8, ["status"]))
}
}

})